// extracted by mini-css-extract-plugin
module.exports = {"column":"OrdersetListRow_column__1Pia1","row":"OrdersetListRow_row__2u09X"};